<div class="moveWrapper">
  <div class="journalToolbar">
    <header class="journalHeader">
      <h2>История товара</h2>
      <div class="eventFilters">
        <mat-form-field appearance="outline" class="eventFilterField">
          <mat-label>События</mat-label>
          <mat-select
            multiple
            placeholder="Все события"
            [value]="selectedEventTypes"
            (selectionChange)="selectEventTypes($event.value)"
            aria-label="Фильтр по событиям"
          >
            <mat-option
              *ngFor="let event of eventOptions"
              [value]="event.value"
              >{{ event.label }}</mat-option
            >
          </mat-select>
        </mat-form-field>
        <button
          mat-stroked-button
          type="button"
          *ngIf="selectedEventTypes.length"
          (click)="selectEventTypes([])"
        >
          <mat-icon>filter_alt_off</mat-icon> Все события
        </button>
      </div>
      <div class="statusBar">
        <span>{{ visibleRows.length }} из {{ rows.length }} загруженных</span>
        <span *ngIf="total">Всего {{ total }}</span>
      </div>
      <button
        *ngIf="dialogRef"
        mat-icon-button
        type="button"
        class="closeHistory"
        aria-label="Закрыть историю товара"
        (click)="dialogRef.close()"
      >
        <mat-icon>close</mat-icon>
      </button>
    </header>

    <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>

    <mat-tab-group
      *ngIf="warehouseTabs.length > 0"
      class="warehouseTabs"
      [selectedIndex]="selectedWarehouseTabIndex"
      (selectedIndexChange)="selectWarehouseTab($event)"
      mat-align-tabs="start"
    >
      <mat-tab *ngFor="let tab of warehouseTabs">
        <ng-template mat-tab-label>
          <span class="tabLabel">
            {{ tab.label }}
            <span class="tabBadge" [class.current]="tab.current">{{
              tab.count
            }}</span>
          </span>
        </ng-template>
      </mat-tab>
    </mat-tab-group>
  </div>

  <div class="emptyState" *ngIf="!loading && !loadError && rows.length === 0">
    {{
      selectedEventTypes.length
        ? "По выбранным событиям записей нет"
        : "История товара не найдена"
    }}
  </div>
  <div class="emptyState" *ngIf="loadError">
    Не удалось загрузить историю
    <button
      mat-stroked-button
      type="button"
      (click)="loadPage({ reset: rows.length === 0 })"
    >
      Повторить
    </button>
  </div>

  <div class="timeline" *ngIf="visibleRows.length > 0">
    <article
      class="timelineEvent"
      *ngFor="let row of visibleRows"
      [ngClass]="getEventClass(row)"
    >
      <time class="eventTime" [attr.datetime]="row.date">
        <strong class="eventDate">{{ getDateLabel(row) }}</strong>
        <span class="eventClock">{{ getTimeLabel(row) }}</span>
      </time>

      <div class="eventRail">
        <span class="eventDot"
          ><mat-icon>{{ getEventIcon(row) }}</mat-icon></span
        >
      </div>

      <div class="eventBody">
        <div class="eventMain">
          <div class="eventTitleLine">
            <strong class="eventTitle">{{ getEventLabel(row) }}</strong>
            <span class="eventStatus" *ngIf="getStatusLabel(row) as status">{{
              status
            }}</span>

            <div
              class="eventHighlights"
              *ngIf="getSupplierLabel(row) || row.invoiceNumber"
            >
              <span
                class="eventSupplier"
                *ngIf="getSupplierLabel(row) as supplier"
              >
                <mat-icon>local_shipping</mat-icon
                ><span
                  >Поставщик: <strong>{{ supplier }}</strong></span
                >
              </span>
              <span class="eventInvoice" *ngIf="row.invoiceNumber">
                <mat-icon>receipt_long</mat-icon
                ><span
                  >Накладная № <strong>{{ row.invoiceNumber }}</strong></span
                >
              </span>
            </div>
          </div>

          <div class="eventDetails">
            <div class="eventMeta">
              <a
                *ngIf="getDocumentLink(row) as link"
                [routerLink]="link"
                target="_blank"
                class="documentLink"
              >
                {{ getDocumentLabel(row) }}
              </a>
              <span *ngIf="!getDocumentLink(row)">{{
                getDocumentLabel(row)
              }}</span>
              <span *ngIf="getWarehouseLabel(row) !== '-'">
                <mat-icon>warehouse</mat-icon>{{ getWarehouseLabel(row) }}
              </span>
              <span
                *ngIf="
                  !getSupplierLabel(row) && getCounterpartyLabel(row) !== '-'
                "
              >
                <mat-icon>business</mat-icon>{{ getCounterpartyLabel(row) }}
              </span>
              <span *ngIf="getManagerLabel(row) !== '-'">
                <mat-icon>person_outline</mat-icon>{{ getManagerLabel(row) }}
              </span>
              <span *ngIf="row.note" class="eventNote">{{ row.note }}</span>
            </div>
            <div
              class="eventReceiptDetails"
              *ngIf="row.organization || row.contract"
            >
              <div
                class="eventOrganization"
                *ngIf="row.organization as organization"
              >
                <mat-icon>account_balance</mat-icon>
                <span
                  >Наша организация:
                  <strong>{{ organization.name || "Не указана" }}</strong></span
                >
              </div>
              <div class="eventContract" *ngIf="row.contract as contract">
                <mat-icon>description</mat-icon>
                <span
                  >Договор:
                  <strong>{{
                    contract.number
                      ? "№ " + contract.number
                      : "без номера (ID " + contract.id + ")"
                  }}</strong></span
                >
              </div>
            </div>
          </div>
        </div>

        <div class="eventValues">
          <div
            class="eventPrice"
            *ngIf="row.price !== null && row.price !== undefined"
          >
            <span class="priceLabel">Цена</span
            ><strong>{{ getPriceLabel(row) }}</strong>
          </div>
          <div class="eventStockValues">
            <strong class="eventQuantity">{{ getQuantityLabel(row) }} шт.</strong>
            <span
              class="eventStockBalance"
              *ngFor="let balanceLabel of getStockBalanceLabels(row)"
              [attr.title]="stockBalanceHint"
            >{{ balanceLabel }}</span>
          </div>
        </div>
      </div>
    </article>
  </div>

  <div
    class="emptyState"
    *ngIf="!loading && rows.length > 0 && visibleRows.length === 0"
  >
    По выбранному складу событий нет
  </div>

  <div class="actions" *ngIf="rows.length > 0 && !allLoaded">
    <button
      mat-stroked-button
      color="primary"
      type="button"
      (click)="loadMore()"
      [disabled]="loadingMore"
    >
      <span *ngIf="!loadingMore">Загрузить ещё</span>
      <span *ngIf="loadingMore">Загрузка...</span>
    </button>
  </div>
</div>
